<mc-modal backdropcloseactiondisabled heading="Print Work Order" fit="small" dimension="small" [open]="open" (closed)="onCancel()">
  <div class="print-dialog-body">
    <p class="print-dialog-hint">Select which sections to include in the printout.</p>

    <mc-checkbox fit="small" label="Include Remarks" [checked]="includeRemarks" (change)="onRemarksChange($event)" ngDefaultControl>
    </mc-checkbox>
  </div>

  <mc-button slot="secondaryAction" appearance="neutral" variant="outlined" (click)="onCancel()" (keydown.enter)="onCancel()">
    Cancel
  </mc-button>

  <mc-button slot="primaryAction" appearance="primary" icon="printer" (click)="onPrint()" (keydown.enter)="onPrint()"> Print </mc-button>
</mc-modal>
